import "can/component/";
import "can/view/stache/";
import "toastr";
import ViewModel from "./sidebar.vm";
import SidebarMenuAccessList from "./sidebar-menu-access-list";
import AccountProperties from "src/models/account-property";

can.Component.extend({
    tag: "sidebar-navigation",
    template: can.view("src/components/sidebar/sidebar.stache"),
    viewModel: ViewModel,
    events: {
        inserted() {
            "use strict";
            // Cache the instance of this view model since this will be a dependency of
            // `sidebar-menu-access-list` when switching accounts
            var URL = window.location.host;
            // Initial check
            this.viewModel.attr("mobileMode", window.matchMedia("(max-width: 768px)").matches);
            // Listen for resize events to update mobileMode
            const updateMobileMode = () => {
                this.viewModel.attr("mobileMode", window.matchMedia("(max-width: 768px)").matches);
            };
            window.addEventListener("resize", updateMobileMode);
            // Clean up on component removal
            this.on("removed", function() {
                window.removeEventListener("resize", updateMobileMode);
            });

            if (URL && URL.includes('azuga')) {
                this.viewModel.attr("copyright", `Azuga ELD \u00A9 ${moment().format("YYYY")}`);
            } else {
                this.viewModel.attr("copyright", `\u00A9 ${moment().format("YYYY")}`);
            }
            Vistracks.Scope.SidebarVM = this.viewModel;
            const hideLogShowEdits = (Vistracks.Scope.AppState.attr("hideLogShowEdits") === "true" ||
                Vistracks.Scope.AppState.attr("hideLogShowEdits") === true);

            Vistracks.Scope.SidebarVM.attr("hideLogShowEdits", hideLogShowEdits);

            const accessList = new SidebarMenuAccessList();
            accessList.bootstrap(this.viewModel);
        },
        "#support-btn click": function (el, event) {
            "use strict";
            event.stopImmediatePropagation();

            Promise.all([
                AccountProperties.findAll({ name: "parent.support.phoneNumber" }),
                AccountProperties.findAll({ name: "parent.support.email" })
            ])
                .then(([phoneResponse, emailResponse]) => {
                    this.viewModel.attr("supportPhone", phoneResponse[0].value ? phoneResponse[0].value : 'Support contact not available');
                    this.viewModel.attr("supportEmail", emailResponse[0].value ? emailResponse[0].value : 'Support email not available');
                    BootstrapDialog.show({
                        title: Locale.translate("Support Contact Information"),
                        size: BootstrapDialog.SIZE_SMALL,
                        closeByBackdrop: false,
                        message: `
                        <div style="font-family: Arial, sans-serif; color: #333;">
                            <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                <span style="font-weight: bold;">${Locale.translate("Contact No.")}</span>
                                <a href="tel:${this.viewModel.attr("supportPhone")}" style="text-decoration: none; color: #007bff; margin-left: 10px;">${this.viewModel.attr("supportPhone")}</a>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <span style="font-weight: bold;">${Locale.translate("Email Address")}</span>
                                <a href="mailto:${this.viewModel.attr("supportEmail")}" style="text-decoration: none; color: #007bff; margin-left: 10px;">${this.viewModel.attr("supportEmail")}</a>
                            </div>
                        </div>
                        `,
                        onshown: function (dialog) {
                            dialog.getModalDialog().css('height', '70px'); // Adjust the height here
                        },
                        buttons: [
                            {
                                label: Locale.translate("Close"),
                                cssClass: "btn btn-link waves-effect",
                                action: dialog => dialog.close()
                            }
                        ]
                    });
                })
                .catch((responseError) => {
                    toastr.error('Please verify if the support contact information for your account is up to date.')
                });

        }
    }
});
